const getApiBaseUrl = () => {
  return '/api/graphql';
}

export async function graphqlClient(query: string, variables: any) {
  try {
    const postData = {
      query,
      variables
    };
    const resp = await fetch(getApiBaseUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    });
    if (resp.ok) {
      return resp.json();
    }
    let err = new Error(`HTTP Error: [${resp.status}] - ${resp.statusText}`);
    err.status = resp.status;
    throw err;
  } catch (error) {
    console.log(`[ERROR] GraphQL Client: [${error.status}]`, error.message);
    throw error;
  }
}
